export class CountStatusBar {
	init(params) {
		this.params = params;

		this.eGui = document.createElement('div');
		this.eGui.className = 'ag-status-name-value';

		var label = document.createElement('span');
		label.innerText = 'Počet řádků: ';
		this.eGui.appendChild(label);

		this.eCount = document.createElement('span');
		this.eCount.className = 'ag-status-name-value-value';

		this.eGui.appendChild(this.eCount);

		params.api.addEventListener('modelUpdated', this.onModelUpdated.bind(this));
	}

	getGui() {
		return this.eGui;
	}

	destroy() {
		this.params.removeEventListener('modelUpdated', this.onModelUpdated);
	}

	onModelUpdated() {
		if (typeof this.params.api.context.totalRowCount != 'undefined') {
			this.eCount.innerText = this.params.api.context.totalRowCount;
		}
	}
}

window.CountStatusBar = CountStatusBar